import request from '@/common/request'

class IPIService {
  getAll() {
    return request.get('/ipis')
  }

  getById(ipiId) {
    return request.get(`/ipis/${ipiId}`)
  }

  create(data) {
    return request.post('/ipis', data)
  }

  update(id, data) {
    return request.patch(`/ipis/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/ipis/${id}`)
  }
}

export default new IPIService()
